export default __webpack_public_path__ + "static/logo-3e9f12db52c0384a61dc745ccfff54bc.png";